import { Color } from '@coast/schemas';
import { isNil } from 'lodash';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useAllTagOptions } from '@shared/components/blocks/lib/tags/hooks';
import { Pill } from '@shared/components/pill';
import { CombinedTagsField } from '@shared/data/entity/fields/CombinedTagsField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

const MAX_TAGS_TO_SHOW = 10;

interface Props {
  field: CombinedTagsField;
  style: StyleProp<ViewStyle>;
}

const combinedTagStyles: StyleProp<ViewStyle> = {
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginLeft: -grid(0.5),
};

export function CombinedTagsCollectionViewField({ field, style }: Props) {
  const { options } = useAllTagOptions();

  if (field.isEmpty || isNil(options)) {
    return null;
  }

  let tags: (MBAPI.TagOption | undefined)[] = [];

  field.tags.forEach((value, key) => {
    value.forEach(v => tags.push(options.find(o => o.fieldName === key && o.slug === v)));
  });

  const tagsToShow = tags.slice(0, MAX_TAGS_TO_SHOW);
  const remainingTagCount = tags.length - MAX_TAGS_TO_SHOW;

  if (isNil(options)) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[combinedTagStyles, style]}>
      {tagsToShow.map(option => {
        if (isNil(option)) {
          return null;
        }
        return (
          <Pill
            key={option.id}
            backgroundColor={option.colorName as Color}
            round
            sections={[option.label]}
          />
        );
      })}
      {remainingTagCount > 0 && (
        <Pill backgroundColor="transparent" sections={[`+${remainingTagCount}`]} round noBorder />
      )}
    </CardCollectionViewFieldContainer>
  );
}
